import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import { Button } from "@trillion/ui/components/ui/button";
import { PageHeader } from "@trillion/ui/components/admin/page-header";
import { ProductForm } from "@/components/products/product-form";
import { adminApi } from "@/lib/admin-api";
import { describeApiError } from "@/lib/api-error";
import type { Product } from "@/types";

export function ProductNewPage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  async function handleSubmit(data: Partial<Product>) {
    setIsLoading(true);
    try {
      await adminApi.products.create(data);
      toast.success("Product created successfully");
      navigate("/products");
    } catch (err) {
      toast.error("Failed to create product", {
        description: describeApiError(err),
      });
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="flex flex-col gap-6 p-6">
      <PageHeader
        title="New Product"
        description="Add a new product to the catalog"
        actions={
          <Button variant="outline" onClick={() => navigate("/products")}>
            <ArrowLeft className="mr-2 size-4" />
            Back to Products
          </Button>
        }
      />
      <ProductForm onSubmit={handleSubmit} isLoading={isLoading} />
    </div>
  );
}
